import { useId } from "react";

export const GXLLogo = ({ height = 32 }: { height?: number }) => {
  const id = useId();
  const paint0 = `${id}-paint0`;
  const paint1 = `${id}-paint1`;
  const width = (height * 200) / 64;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 200 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M58.8943 24.4415H47.9719V24.4579H28.5084C25.3503 24.4579 22.7808 27.1024 22.7808 30.3527C22.7808 33.6031 25.3503 36.2476 28.5084 36.2476H50.1516V51.9535H30.8022C20.1344 51.9535 11.4527 43.0212 11.4527 32.0393C11.4527 21.0574 20.1344 12.1279 30.8022 12.1279H55.3861C55.5028 12.1279 55.6168 12.1224 55.7308 12.1169H58.364C59.8622 12.1169 61.0767 10.867 61.0767 9.32508V6.9071C61.1005 6.68605 61.1164 6.46226 61.1164 6.23302C61.1164 6.00377 61.1032 5.77999 61.0767 5.55893V3.12731C61.0767 1.58537 59.8622 0.335449 58.364 0.335449H30.8048C22.6296 0.335449 14.9079 3.64857 9.06352 9.66076C3.21917 15.6784 0 23.6255 0 32.0393C0 40.4531 3.21917 48.4002 9.06087 54.4151C14.9052 60.4301 22.6243 63.7404 30.8022 63.7404H55.8793C59.0375 63.7404 61.607 61.096 61.607 57.8456V27.2334C61.607 25.6914 60.3925 24.4415 58.8943 24.4415Z"
        className="gxl-logo-ink"
        fill="#1B182E"
      />
      <path
        d="M84.3323 1.82018C83.2451 0.701248 81.8105 0.0844727 80.2911 0.0844727C77.1329 0.0844727 74.5634 2.72896 74.5634 5.97931C74.5634 7.54308 75.1627 9.01952 76.2499 10.1384L93.8678 28.2705C94.8966 29.3294 95.3766 30.5275 95.3766 32.0394C95.3766 33.5513 94.8675 34.7767 93.8678 35.8083L76.2499 53.9404C75.1627 55.0593 74.5607 56.5357 74.5607 58.1022C74.5607 61.3526 77.1302 63.9971 80.2884 63.9971C81.8052 63.9971 83.2397 63.3803 84.3269 62.2614L101.945 44.1293C105.092 40.8899 106.827 36.597 106.827 32.0421C106.827 27.4873 105.092 23.1944 101.945 19.955L84.3323 1.82018Z"
        className="gxl-logo-ink"
        fill="#1B182E"
      />
      <path
        d="M130.939 0.0847603C129.422 0.0847603 127.988 0.701535 126.9 1.82046L109.609 19.6169C108.522 20.7385 107.922 22.2122 107.922 23.7733C107.922 27.0782 110.439 29.6681 113.65 29.6681C115.169 29.6681 116.604 29.0513 117.691 27.9324L134.98 10.1387C136.067 9.01981 136.667 7.54337 136.667 5.97687C136.667 2.72652 134.097 0.0820312 130.939 0.0820312V0.0847603Z"
        className="gxl-logo-accent"
        fill={`url(#${paint0})`}
      />
      <path
        d="M117.689 36.0621C116.57 34.9104 115.212 34.3291 113.647 34.3291C110.489 34.3291 107.92 36.9736 107.92 40.2239C107.92 41.785 108.519 43.2614 109.604 44.3776L126.895 62.2586H126.898C127.985 63.383 129.42 63.9998 130.936 63.9998C134.095 63.9998 136.664 61.3553 136.664 58.105C136.664 56.5412 136.065 55.062 134.98 53.9485L117.686 36.0648L117.689 36.0621Z"
        className="gxl-logo-accent"
        fill={`url(#${paint1})`}
      />
      <path
        d="M197.287 51.9646H192.024V51.9537H162.078C161.113 51.9537 160.267 51.0831 160.267 50.0898V5.89484C160.267 5.78295 160.264 5.67378 160.256 5.56462V2.79186C160.256 1.24992 159.042 0 157.544 0H151.524C150.026 0 148.812 1.24992 148.812 2.79186V50.0898C148.812 57.6166 154.762 63.7434 162.078 63.7434H197.287C198.786 63.7434 200 62.4935 200 60.9515V54.7565C200 53.2146 198.786 51.9646 197.287 51.9646Z"
        className="gxl-logo-ink"
        fill="#1B182E"
      />
      <defs>
        <linearGradient
          id={paint0}
          x1="107.922"
          y1="14.8751"
          x2="136.667"
          y2="14.8751"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#312A58" />
          <stop offset="1" stopColor="#6A5CBE" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="107.92"
          y1="49.1644"
          x2="136.664"
          y2="49.1644"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#312A58" />
          <stop offset="1" stopColor="#6A5CBE" />
        </linearGradient>
      </defs>
    </svg>
  );
};
